import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { MobileInventorIntegrationStatus } from '../model/types';

export const updateMobileInventorIntegrationAPI = async (enabled: boolean) => {
  const response = await baseAPI.patch<MobileInventorIntegrationStatus>(
    'mobile-inventor-push/integration',
    { enabled },
  );
  return response.data;
};

export const useUpdateMobileInventorIntegration = () =>
  useMutation({
    mutationFn: updateMobileInventorIntegrationAPI,
    onSuccess: (data) => {
      queryClient.setQueryData(
        QUERY_KEYS.MOBILE_INVENTOR_PUSH_INTEGRATION(),
        data,
      );
      toast.success(
        data.mobileInventorEnabled
          ? 'Push notifications enabled'
          : 'Push notifications disabled',
      );
    },
    onError: (error: AxiosError<{ message?: string }>) => {
      toast.error(
        error.response?.data?.message ?? 'Failed to update push notifications',
      );
    },
  });
